<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true">
        <div class="buttons">
            <ng-container>
                <ui-button type="primary" [routerLink]="['/settings', 'custom-fields', 'fields', 'create']">
                    <mat-icon svgIcon="plus"></mat-icon>{{ 'settings.custom-fields.createCustomField' | translate }}
                </ui-button>
            </ng-container>
        </div>
    </app-header>

    <div class="app-grid">
        <div class="columns-9">
            <div class="ui segment">
                <div class="app-grid">
                    <app-field-group-form #fieldGroupForm [fieldGroup]="fieldGroup"></app-field-group-form>
                </div>

                <div class="app-grid">
                    <div class="columns-12">
                        <h3>{{ 'settings.custom-fields.customFields' | translate }}</h3>

                        <p *ngIf="customFields.length > 0; else noCustomFields">
                            {{ 'settings.custom-fields.rearrangeFieldsNotice' | translate }}
                        </p>
                        <ng-template #noCustomFields>
                            <p>{{ 'settings.custom-fields.noCustomFields' | translate }}</p>
                        </ng-template>

                        <div *ngIf="displayDefaultFields" class="default fields">
                            <div
                                *ngFor="let name of defaultFieldNames"
                                class="default field-container"
                                [ngClass]="customFields.length > 0 ? 'has-customs-below' : ''"
                            >
                                <div class="default field padding-top-1 padding-bottom-1">
                                    <div class="margin-right-1">
                                        <mat-icon svgIcon="dragAndDrop"></mat-icon>
                                    </div>

                                    <span>{{ name | translate }}</span>
                                </div>
                            </div>
                        </div>

                        <div
                            *ngIf="displayCustomFields"
                            id="customFields"
                            class="custom fields"
                            cdkDropList
                            (cdkDropListDropped)="drop($event)"
                        >
                            <div
                                *ngFor="let field of customFields; let i = index"
                                [attr.data-cy]="'custom-field-drag-handle-' + i"
                                cdkDrag
                                class="custom field-container"
                            >
                                <div class="custom field padding-top-1 padding-bottom-1">
                                    <div class="drag-icon margin-right-1">
                                        <mat-icon svgIcon="dragAndDrop"></mat-icon>
                                    </div>

                                    <span>{{ field.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: flex-end">
                <ui-button (click)="cancel($event)">{{ 'cancel' | translate }}</ui-button>
                <ui-button (click)="onSave(fieldGroupForm)" type="primary">{{ 'save' | translate }}</ui-button>
            </div>
        </div>

        <div class="columns-3">
            <div class="ui segment">
                <app-segment-header title="{{ 'settings.custom-fields.fieldGroups' | translate }}"></app-segment-header>

                <p>{{ 'settings.custom-fields.createFieldGroupsNotice' | translate }}</p>

                <p>
                    <a href="{{ '4414759324951' | i18nHelpCentre }}">{{
                        'settings.custom-fields.learnMore' | translate
                    }}</a
                    >{{ 'settings.custom-fields.aboutFieldGroups' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>
